import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from '../../components/Tooltip';
import { NameCell } from './NameCell.css';
const ColumnWithTooltip = ({ title, children, inheritWidth, disableInteractive = true, typeAlignment, style = {}, }) => {
    return (_jsx(Tooltip, Object.assign({ style: style, title: title || '', disableInteractive: disableInteractive }, { children: _jsx(NameCell, Object.assign({ inheritWidth: inheritWidth, typeAlignment: typeAlignment }, { children: children })) })));
};
export default ColumnWithTooltip;
